import type { ListResponse } from '../../goodstack'

import type { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { SearchOpportunitiesQuery, SearchOpportunitiesResponseRow } from './searchOpportunities.types'

const ENDPOINT = 'v1/opportunities-search'

export const searchOpportunities: InfiniteQueryFn<
  [string, SearchOpportunitiesQuery],
  string,
  ListResponse<SearchOpportunitiesResponseRow>
> = async (
  client,
  [
    _,
    {
      type,
      locationType,
      relevantSkills,
      targetCountries,
      city,
      campaignId,
      query,
      direction = 'ASC',
      pageSize = 25,
      timeOfDay,
      activities,
      orderBy,
      includeUnlisted
    }
  ],
  cursor
) =>
  (
    await (cursor
      ? client.get<ListResponse<SearchOpportunitiesResponseRow>>(cursor, {
          withCredentials: true
        })
      : client.get<ListResponse<SearchOpportunitiesResponseRow>>(ENDPOINT, {
          params: {
            pageSize,
            direction,
            query,
            relevantSkills,
            ...(targetCountries && { targetCountries }),
            ...(city?.length && { city }),
            ...(campaignId && { campaignId }),
            locationType,
            type,
            timeOfDay,
            activities,
            orderBy: orderBy ?? 'relevance',
            ...(includeUnlisted && { includeUnlisted })
          },
          withCredentials: true
        }))
  ).data
